import React from 'react'

interface ButtonOption {
  key: string
  label: string
  disabled?: boolean
}

interface ButtonGroupProps {
  options: ButtonOption[]
  value?: string
  onChange: (key: string) => void
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  options,
  value,
  onChange,
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-2 text-sm', 
    lg: 'px-4 py-3 text-base'
  }

  return (
    <div className={`inline-flex rounded-md shadow-sm ${className}`}>
      {options.map((option, index) => {
        const isSelected = value === option.key
        const isFirst = index === 0
        const isLast = index === options.length - 1
        
        return (
          <button
            key={option.key}
            type="button"
            onClick={() => !option.disabled && onChange(option.key)}
            disabled={option.disabled}
            className={`
              ${sizeClasses[size]}
              border border-gray-300 font-medium transition-all duration-200
              focus:z-10
              ${isFirst ? 'rounded-l-md' : ''}
              ${isLast ? 'rounded-r-md' : ''}
              ${!isFirst ? '-ml-px' : ''}
              ${isSelected 
                ? 'bg-blue-600 text-white border-blue-600 z-10' 
                : 'bg-white text-gray-700 hover:bg-gray-50'
              }
              ${option.disabled
                ? 'opacity-50 cursor-not-allowed'
                : 'cursor-pointer hover:shadow-sm'
              }
            `}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

export default ButtonGroup